import { atom } from "jotai";

import { currentSignUpRowAtom } from "./eventSignUpProcess";
import { unknownGuestsAssignedToPayersAtom } from "./stores";

export const unknownGuestsPerPrimaryChargeTypeAtom = atom((get) => {
  const currentSignUpRow = get(currentSignUpRowAtom);
  const unknownGuestRegistrations =
    currentSignUpRow?.registrations.filter(
      (r) => !r.registrant.playerId && r.type === "GUEST"
    ) || [];

  const summaryMap: Record<string, number> = {};

  unknownGuestRegistrations.forEach((registration) => {
    if (!!summaryMap[registration.primaryRegistrationChargeTypeId ?? ""]) {
      summaryMap[registration.primaryRegistrationChargeTypeId ?? ""]++;
    } else {
      summaryMap[registration.primaryRegistrationChargeTypeId ?? ""] = 1;
    }
  });

  const currentPaymentMap = Object.keys(summaryMap).map((key) => {
    const primaryChargeId = key;
    const total = summaryMap[key];
    return {
      primaryChargeId,
      total,
    };
  });

  return currentPaymentMap;
});

export const remainingUnpaidGuestCountsAtom = atom((get) => {
  const totalPaidUnknownGuests = get(unknownGuestsAssignedToPayersAtom);
  const unknownGuestCountsPerChargeType = get(
    unknownGuestsPerPrimaryChargeTypeAtom
  );

  //Start with totals
  const maxUnknownGuestsByChargeType: {
    primaryChargeId: string | null;
    count: number;
  }[] = [
    ...unknownGuestCountsPerChargeType.map((ug) => ({
      primaryChargeId: ug.primaryChargeId,
      count: ug.total,
    })),
  ];
  //remove paid guests
  const remainingUnpaidGuestCounts = maxUnknownGuestsByChargeType.flatMap(
    (item) => {
      totalPaidUnknownGuests.forEach((pug) => {
        if (pug.primaryChargeId === item.primaryChargeId) {
          item.count = item.count - pug.unknownGuestCount;
        }
      });
      if (item.count !== 0) {
        return { ...item };
      }
      return [];
    }
  );

  return remainingUnpaidGuestCounts;
});

export const isUnknownGuestCountValidAtom = atom((get) => {
  const remaining = get(remainingUnpaidGuestCountsAtom);
  return remaining.length === 0;
});
